import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useDefaultSortByOptions() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('newest'),
        value: '-createdAt',
      },
      {
        label: t('oldest'),
        value: 'createdAt',
      },
    ],
    [t],
  );
}
